import axios from "../axios";

const getAllOrders = (inputid) => {
    // su dung cu phap cua template string
    return axios.get(`/api/get-all-orders?id=${inputid}`);
    // return axios.get('/api/get-all-order', {
    //     data: {
    //         id: inputid
    //     }
    // });

}
const createNewOrderService = (data) => {
    console.log("hello from createNewOrder Service:", data);
    return axios.post('/api/create-new-order', data)
}
const deleteOrderService = (data) => {
    // console.log("hello from createNewOrder Service:", DataTransfer);
    // return axios.delete('/api/delete-order', data)
    return axios.delete('/api/delete-order', {
        data: {
            id: data.id
        }
    });
}
const editOrderService = (data) => {
    console.log("hello from editOrderService Service:", data.id);
    return axios.put('/api/edit-order', data);

}
export {
    getAllOrders,
    createNewOrderService,
    deleteOrderService,
    editOrderService
}